import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { DataImportExport } from '../components/admin/DataImportExport';
import { KnowledgeExport } from '../components/admin/KnowledgeExport';
import { StorageHealth } from '../components/admin/StorageHealth';
import { Page, PageHeader } from '../components/ui';

export const AdminPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Page>
        <PageHeader title="Data" />
        <DataImportExport />
        <div className="mt-8">
          <KnowledgeExport />
        </div>
        <div className="mt-8">
          <StorageHealth />
        </div>
      </Page>
    </DashboardLayout>
  );
};
